import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  position: number
}

export default function QuestionPosition({ position }: Props) {
  return (
    <Box
      height="s24"
      width="s24"
      background="viridian200"
      borderRadius={{
        all: 'rel333',
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Text.Normal size="200" weight="semibold" color="viridian1200">
        {position}
      </Text.Normal>
    </Box>
  )
}
